<template>
  <!-- Shared Pro Rally card. Rendered inside PricingTable on /download and on
       its own at the top of /pro-features, so the feature list and its anchor
       links only ever exist in one place. -->
  <div class="card card-featured">
        <div class="card-header">
          <picture class="contents">
            <source srcset="/images/Subscriptions/icon-pro-5a3cf2341df65856bac03b60a1d584cd.webp" type="image/webp" />
            <img
            class="card-icon"
            src="/images/Subscriptions/icon-pro-5a3cf2341df65856bac03b60a1d584cd.png"
            alt="Pro Rally"
            width="256"
            height="256"
            loading="lazy"
            decoding="async"
            />
          </picture>
          <h3>Pro Rally</h3>
          <div class="price"><span class="cur">$</span>199<span class="usd">USD</span></div>
          <div class="duration">{{ tt.proDuration }}</div>
          <div class="note">{{ tt.proNote }}</div>
        </div>
        <div class="perks-heading perks-heading--block">{{ tt.proPlus }}</div>
        <ul class="perks perks-two-col">
          <li v-for="item in PRO_ITEMS" :key="item.key">
            <router-link :to="`/pro-features#${item.anchor}`" class="perk-link"
              ><span v-html="tt.pro[item.key]"></span
            ></router-link>
          </li>
      </ul>
  </div>
</template>

<script>
import { DOWNLOAD_CONTENT } from '../content/downloadPage';

// Order and /pro-features anchors of the Pro perks; the labels come from the
// pricing text (DOWNLOAD_CONTENT[lang].pricing.pro), English by default.
const PRO_ITEMS = [
  { key: 'pro-license', anchor: 'pro-license' },
  { key: 'commercial-use', anchor: 'commercial-use' },
  { key: 'header-image', anchor: 'header-image' },
  { key: 'map-sources', anchor: 'map-sources' },
  { key: 'custom-icons', anchor: 'custom-icons' },
  { key: 'qr-code', anchor: 'qr-code' },
  { key: 'speed-elevation', anchor: 'speed-elevation' },
  { key: 'gps-recorder', anchor: 'gps-recorder' },
  { key: 'gps-validator', anchor: 'gps-validator' },
  { key: 'elevation-profile', anchor: 'elevation-profile' },
  { key: 'track-color', anchor: 'track-color' },
  { key: 'moto-rolls', anchor: 'moto-rolls' },
  { key: 'waypoint-numbers', anchor: 'waypoint-map-icons' },
  { key: 'waypoint-controls', anchor: 'waypoint-map-icons' },
  { key: 'street-view', anchor: 'street-view' },
  { key: 'track-distance-hover', anchor: 'track-distance-hover' },
  { key: 'et-distance', anchor: 'et-distance' },
  { key: 'tulip-assist', anchor: 'tulip-assist' },
  { key: 'zone-controls', anchor: 'zone-controls' },
  { key: 'smart-icons', anchor: 'smart-icons' },
  { key: 'kmz-gpx-export', anchor: 'kmz-gpx-export' },
];

export default {
  name: 'ProRallyCard',
  props: {
    t: { type: Object, default: null },
  },
  data() {
    return { PRO_ITEMS };
  },
  computed: {
    tt() {
      return this.t || DOWNLOAD_CONTENT.en.pricing;
    },
  },
};
</script>

<style scoped>
.rn-pricing {
  padding: 10px 0;
}

.card {
  background: #393a44;
  text-align: center;
  display: flex;
  flex-direction: column;
}

.card-featured {
  background-color: #2c2d3b;
  border: 3px solid #ff0000;
}

.card-header {
  padding: 20px;
}

.card-icon {
  max-width: 110px;
  margin: 0 auto;
  padding-bottom: 16px;
}

.card-header h3 {
  font-family: 'Russo One', sans-serif;
  text-transform: uppercase;
  color: #fff;
  text-shadow: 0 0 3px #000;
  font-size: 21px;
  margin: 0;
}

.price {
  font-family: 'Russo One', sans-serif;
  color: #fff;
  text-shadow: 0 0 3px #000;
  font-size: 35px;
  line-height: 0.9em;
  margin-top: 10px;
}

.price .cur {
  font-size: 0.55em;
  vertical-align: top;
  margin-right: 2px;
}

.price .usd {
  font-size: 0.3em;
  color: #aeb0c5;
  vertical-align: top;
  margin-left: 2px;
  text-transform: uppercase;
}

.duration,
.note {
  font-family: 'Electrolize', sans-serif;
  text-transform: uppercase;
  text-shadow: 0 0 2px #000;
  font-size: 13px;
  line-height: 18px;
}

.duration {
  color: #aeb0c5;
  margin-bottom: 10px;
}

.note {
  color: #eee;
}

.perks {
  margin: 0;
  padding: 0;
  list-style: none;
}

.perks li {
  text-align: left;
  background-color: #484a61;
  padding: 10px 20px;
  color: #e5e5e5;
  font-size: 13px;
  line-height: 18px;
}

.perks li:nth-child(even) {
  background-color: #4c4f6e;
}

.perks-heading {
  font-weight: 700;
  color: #fff;
}

.perks-heading--block {
  text-align: left;
  background-color: #484a61;
  padding: 10px 20px;
  font-size: 13px;
  line-height: 18px;
}

/* Pro Rally two-column perks */
.perks-two-col .perk-link {
  color: inherit;
  text-decoration: none;
  display: block;
}

.perks-two-col .perk-link:hover,
.perks-two-col .perk-link:focus-visible {
  color: #fff;
  text-decoration: underline;
}

.perks-two-col {
  display: grid;
  grid-template-columns: 1fr 1fr;
}

.perks-two-col li:nth-child(even) {
  background-color: #484a61;
}

.perks-two-col li:nth-child(4n + 3),
.perks-two-col li:nth-child(4n) {
  background-color: #4c4f6e;
}

@media (max-width: 640px) {
  .perks-two-col {
    grid-template-columns: 1fr;
  }
}
</style>
